import { createSlice } from "@reduxjs/toolkit";

const LibraryDatas = [];

const librarySliceData = createSlice({
    name: "librarySliceData",
    initialState: { LibraryDatas },
    reducers: {
        resetLibraryData(state) {
            state.LibraryDatas = LibraryDatas
        },
        setLibraryData(state, action) {
            state.LibraryDatas = action.payload
        },
    }
})

export const { setLibraryData, resetLibraryData } = librarySliceData?.actions;

export default librarySliceData?.reducer;